import {
    IRIS_LOAD_ERROR_PAGE,
    IRIS_PAGE_LOAD_SUCCESS,
    IRIS_PAGE_LOAD_REQUEST,
} from 'yoda-site-components/lib/actionTypes/IrisActionTypes';

/**
 * This function will used only for redux middleware only to track tagging based on action request
 */

/* istanbul ignore next */
const PdpIrisMiddleware = store => next => action => { // eslint-disable-line
    if (!__SERVER__) {
        switch (action.type) {
            case IRIS_PAGE_LOAD_REQUEST: {
                store.dispatch({
                    type: 'SHIIPING_AND_RETURNS_DATA_LOAD_REQUEST',
                });
                break;
            }
            case IRIS_LOAD_ERROR_PAGE: {
                store.dispatch({
                    type: 'SHIIPING_AND_RETURNS_DATA_ERROR',
                });
                break;
            }
            case IRIS_PAGE_LOAD_SUCCESS: {
                store.dispatch({
                    type: 'SHIIPING_AND_RETURNS_DATA_SUCCESS',
                });
                break;
            }
            default:
                break;
        }
    }
    return next(action);
};

export default PdpIrisMiddleware;
